<template>
	<div class="wechat">
		<!--  v-loading="info_loading" -->
		<div class="info-box">
			<div class="info">
				<div class="logo">
					<img src="~assets/img/wxCorpIcon_big.png" alt="">
				</div>
				<div class="name-box">
					<div class="name">{{wechat_info !== null ? wechat_info.company_name : '暂未接入'}}</div>
					<div class="id">企业ID: {{wechat_info !== null ? wechat_info.corpid : '无'}}</div>
				</div>
			</div>
			<div class="btn">
				<el-button v-if="wechat_info !== null" class="synch" @click="openSynch">重新同步资料</el-button>
				<el-button v-if="wechat_info !== null" class="access" @click="toCourse">更改接入信息</el-button>
				<el-button v-else class="access" @click="toCourse">立即接入</el-button> 
			</div>
		</div>
		<!--  -->
		<div class="join_box" v-if="wechat_info !== null">
			<!--  -->
			<!--  -->
			<div class="join_item" v-loading="ewm_loading">
				<!--  -->
				<div class="img_box" >
					<canvas id="canvas1"></canvas>
				</div>
				<!--  -->
				<div class="info" >
					<div class="tit" >
						<span>
							扫码加入
						</span>
					</div>
					<div class="txt">
						企业微信成员用企业微信扫码申请加入
					</div>
				</div>
				<!--  -->
			</div>
			<!--  -->
			<!--  -->
			<div class="join_item" style="margin-left: 20px;" v-loading="link_load">
				<!--  -->
				<div class="info">
					<div class="tit">
						<span>
							链接加入
						</span>
						<div class="copy" v-clipboard:copy="linkadd" v-clipboard:success="copy_success"
							v-clipboard:error="copy_error">
							复制链接
						</div>

					</div>
					<p class="url_txt ">
						{{linkadd || ''}}
					<p>
					<div class="txt">
						企业微信成员用企业微信打开链接申请加入
					</div>
				</div>
				<!--  -->
			</div>
			<!--  -->
		</div>

		<!--  -->
		<div class="wx_table" v-if="wechat_info !== null">

			<el-table v-loading="tab2_loading" :data="record_data"
				:header-cell-style="{background:'rgb(249,249,249)'}" ref="multipleTable" :row-style="{height: '40px'}"
				style="width: 100%;margin: 0 auto">
				<!--  -->
				<!--  -->
				<el-table-column align="left" prop="name" label="成员姓名">
				</el-table-column>
				<!--  -->
				<!--  -->
				<el-table-column align="center" prop="phone" label="成员电话">

					<template slot-scope="scope">
						<div slot="reference" class="name-wrapper">

							<span style="color: #0076fe;">
								{{ scope.row.phone }}
							</span>

						</div>
					</template>

				</el-table-column>
				<!--  -->
				<!--  -->
				<el-table-column align="center" prop="join_time" label="加入时间">
				</el-table-column>
				<!--  -->
				<!-- Configuration  -->
				<el-table-column align="center" label="操作">

					<template v-slot="scope">
						<div v-if="scope.row.status == 0">
							<span class="wx_btn btn1" @click="adopt(scope.row, 1)">审核通过</span>
							<span class="wx_btn btn2" @click="adopt(scope.row, 2)" style="margin-left: 8px;">审核拒绝</span>
						</div>
						<span class="wx_btn btn3" v-else-if="scope.row.status == 1">已加入</span>
						<span class="wx_btn btn3" v-else>已拒绝</span>
					</template>

				</el-table-column>
				<!--  -->
				<!--  -->
			</el-table>

		</div>
		<!--  -->
		<div class="pagin_box FlexEnd" v-if="wechat_info !== null">

			<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页" next-text="下一页"
				:page-sizes="[20, 50, 100, 200, 500]" :page-size="table2_page.pagesize" :pager-count='5'
				@size-change="SizeChange2" @current-change="currChange2" :total="table2_page.total">
			</el-pagination>

		</div>
		<!--  -->

		<!--  -->
		<div class="table">
			<div class="title-box">
				<p class="title">接入企业微信的优势</p>
			</div>
			<el-table :data="tableData" :header-cell-style="{background:'rgb(249,249,249)'}" border ref="multipleTable"
				:row-style="{height: '40px'}" style="width: 100%">
				<el-table-column prop="title" label="" align="center" width="310">
				</el-table-column>
				<el-table-column prop="wx" align="center" label="个人微信">
				</el-table-column>
				<el-table-column prop="qywx" align="center" label="企业微信">
				</el-table-column>
			</el-table>
		</div>

		<Dialog :show.sync="synch_show" :name_width="synch_dialog" 
		class="dialog" :show_closer="false" :close_modal="false"
		:close_press="false"
			  >
			<span slot="body">
				<!--        同步资料选择  1-->
				<div class="synch_select" v-if="dialog_type === 1">
					<p class="title">请选择需要重新同步的资料类型：</p>
					<div class="check-box">
						<el-checkbox v-model="synch_select_info.class_info">组织架构信息</el-checkbox>
						<el-checkbox v-model="synch_select_info.label_info">标签信息</el-checkbox>
						<el-checkbox v-model="synch_select_info.member_info">客户信息</el-checkbox>
						<el-checkbox v-model="synch_select_info.group_info">群信息</el-checkbox>
					</div>
				</div>
				<!--        同步资料进度  2-->
				<div class="synch_speed" v-else-if="dialog_type === 2">
					<el-progress :percentage="progress_bar | round" style="height: 10px;"></el-progress>
					<div class="return_info">
						<p v-if="synch_select_info.class_info">
							组织架构信息&nbsp;
							<span class="wait" v-if="class_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="class_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="class_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="class_state === 2">{{class_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.label_info">
							标签信息&nbsp;
							<span class="wait" v-if="label_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="label_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="label_state === 2">同步成功</span>&nbsp;
							<span class="data-text" v-if="label_state === 2">{{label_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.member_info">
							客户信息&nbsp;
							<span class="wait" v-if="member_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="member_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="member_state === 2">同步成功</span>&nbsp;
							<span class="data-text"
								v-if="member_state === 1 || member_state === 2">{{member_msg}}条数据</span>
						</p>
						<p v-if="synch_select_info.group_info">
							群信息&nbsp;
							<span class="wait" v-if="group_state === 0">等待同步</span>&nbsp;
							<span class="ongoing" v-if="group_state === 1">正在同步</span>&nbsp;
							<span class="success" v-if="group_state === 2">同步成功</span>&nbsp;
							<span class="data-text"
								v-if="group_state === 1 || group_state === 2">{{group_msg}}条数据</span>
						</p>
					</div>
				</div>
				<!--        同步成功-->
				<div class="synch_success" v-else-if="dialog_type === 3">
					<span>
						<svg t="1624935075201" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2431" width="80" height="80">
							<path
								d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z"
								fill="#52C41A" p-id="2432"></path>
						</svg>
					</span>
					<div class="title-box">
						<p class="title">数据同步成功</p>
						<p class="small-title">您可以开始使用系统啦</p>
					</div>
				</div>
			</span>
			<div slot="footer">
				<el-button v-if="dialog_type === 1" type="primary" @click="start_synch_dialog" class="blueBtn">开始同步
				</el-button>
				<!-- <el-button v-else-if="dialog_type === 2" type="primary" @click="suspend_synch_dialog" class="suspend">暂停
				</el-button> -->
				<el-button v-else-if="dialog_type === 3" type="primary" @click="return_synch_dialog" class="blueBtn">返回
				</el-button>
				<el-button @click="close_synch_dialog">取 消</el-button>
			</div>
		</Dialog>


		<Dialog :show.sync="import_member_show1" :name_width="import_member_dialog1" class="import_member_dialog">
			<span slot="body">
				<el-form ref="form" label-width="150">
					<el-form-item label="选择角色：">
						<el-select v-model="role_id" placeholder="请选择角色" style="width: 455px;">
							<el-option v-for="item in rolelist" :key="item.role_id" :label="item.name"
								:value="item.role_id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否自动修改姓名：">
						<el-radio v-model="qw_radio" :label="1">修改</el-radio>
						<el-radio v-model="qw_radio" :label="0">不修改</el-radio>
					</el-form-item>
				</el-form>
			</span>
			<div slot="footer">
				<el-button type="primary" @click="save_import_qw">确 认</el-button>
				<el-button @click="close_import_qw">取 消</el-button>
			</div>
		</Dialog>

	</div>
</template>

<script>
	import {
		getQwConfig,
		synchroQwDepartment,
		synchroQwTag,
		synchroQwCustomer,
		getQwMember,
		synchroQwCustomerBase,

		getqwauthurl,
		Addauthorization,
		edit_recordlist,
		recordlist,
	} from 'network/hk_wechat';

	import {
		getRoleList
	} from 'network/hk_role'

	import QRCode from 'qrcode';

	import Dialog from "components/content/dialog/Dialog";
	
	import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'
	
	export default {
		name: "Wechat",
		components: {
			Dialog,
			QRCode: QRCode,
		},
		data() {
			return {
				is_powerAdd: false,
				is_powerEdit: false,
				is_powerDel: false,
				is_powerImp: false,
				is_powerExp: false,
				is_powerRec: false,
				
				info_loading:true,
				link_load:true,
				ewm_loading: true,
				tab2_loading: true,

				currentAlert: {},
				currentstatus: 1,

				role_id: '',
				qw_radio: 1,
				import_member_show1: false,
				import_member_dialog1: {
					name: '修改授权记录状态',
					width: '500px'
				},

				rolelist: [],
				// 扫码加入 
				codeadd: '',
				// 链接加入 
				linkadd: '',
				table2_page: {
					pagesize: 10,
					total: 1,
					current: 1,
				},

				record_data: [],



				tableData: [{
					title: '员工离职',
					wx: '资产属于个人，客户资源被带走',
					qywx: '资产属于企业、管理员可将离职员工的客户资源一键分配给其他员工'
				}, {
					title: '客户数量',
					wx: '5千',
					qywx: '最高5万（可持续扩容）'
				}, {
					title: '对外形象',
					wx: '无任何标志',
					qywx: '有企业认证标识，专业靠谱'
				}, {
					title: '社群运营',
					wx: '无辅助工具',
					qywx: '入群欢迎语、自动踢人、违规发言监控'
				}, {
					title: '监控聊天',
					wx: '不支持',
					qywx: '支持管理员在线监控员工聊天记录'
				}, {
					title: '消息群发',
					wx: '200人/次',
					qywx: '不限制单次群发人数'
				}, {
					title: '营销风险',
					wx: '过度营销容易被举报或封号',
					qywx: '官方支持营销，风险低'
				}, {
					title: '硬件成本',
					wx: '需要配备手机和电话卡进行养号',
					qywx: '不需要'
				}, ],

				wechat_info: {},

				member_list: [],

				// 同步信息弹窗
				synch_show: false,
				synch_dialog: {
					name: '企微资料同步',
					width: '625px'
				},

				dialog_type: 1,

				synch_select_info: {
					class_info: true,
					label_info: true,
					member_info: true,
					group_info: true
				},
				// 同步进度条
				progress_bar: 0,

				// 同步状态  0 等待同步、1 正在同步、2 同步成功
				class_state: 0,
				label_state: 0,
				member_state: 0,
				group_state: 0,

				// 同步返回结果
				class_msg: 0,
				label_msg: 0,
				member_msg: 0,
				group_msg: 0,

				// 进度条百分比
				data_num: {
					sum: 100,
					num: 0
				},

				// 正在同步的客户userid
				userid: '',
				next_cursor: '',

				// 正在执行同步的客户索引
				member_index: 0,
				group_index: 0
			}
		},
		filters: {
			round(num) {
				return Math.ceil(num)
			}
		},
		created() {
			this.getQwConfig()
			this.getQwauth_Url()

			this.record_list()

			this.getRole_List()
			this.judgePower()
		},
		methods: {
			judgePower() {
				this.is_powerAdd = retupower('198')
				this.is_powerEdit = retupower('199')
				this.is_powerDel = retupower('200')
				this.is_powerImp = retupower('201')
				this.is_powerExp = retupower('202')
				this.is_powerRec = retupower('203')
			},

			save_import_qw() {
				if (this.role_id == '') {
					this.$message({
						showClose: true,
						message: '请选择角色',
						duration: 2000,
						type: 'error',
						offset: 100,
					});
				} else {

					let data = {
						record_id: this.currentAlert.record_id,
						status: 1,
						is_editname: this.qw_radio,
						role_id: this.role_id,
					}
					this.editRecordlist(data)

					// record_id	是	int	记录
					// status	是	int	状态：0：未通过1：通过2:拒绝
					// is_editname	否	int	是否修改名称
					// role_id	否	int	角色id

				}

			},

			close_import_qw() {
				this.import_member_show1 = false
			},
			// 获取角色列表
			getRole_List() {
				getRoleList().then(res => {
					if (res.code === 10000) {
						this.rolelist = res.result
					}
				})
			},
			// 记录列表
			record_list() {
				var that = this
				let data = {
					pagesize: this.table2_page.pagesize,
					page: this.table2_page.current,
				}
				recordlist(data).then(res => {
					console.log(res, 'recordlist')
					if (res.code === 10000) {
						that.table2_page.current = res.result.current_page
						that.table2_page.total = res.result.total
						that.record_data = res.result.data

						that.tab2_loading = false
					}
				})
			},
			// 生成二维码
			useqrcode() {
				var canvas = document.getElementById('canvas1')
				QRCode.toCanvas(canvas, this.linkadd, (error) => {
					if (error) console.error(error)
					console.log('QRCode success!');
				})
				this.ewm_loading = false
			},
			// 获取授权链接
			getQwauth_Url() {
				getqwauthurl().then(res => {
					if (res.code === 10000) {
						this.linkadd = res.result
						this.useqrcode()
						this.link_load = false
					}
				})
			},

			// 复制成功时的回调函数 
			// https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww2d0202d79b62af76&redirect_uri=https%3A%2F%2Fscrm.51kuaiding.com%2Fscrm%2Fhome&response_type=code&scope=snsapi_privateinfo&state=#wechat_redirect&agentid=1000047
			copy_success(e) {
				this.$message({
					showClose: true,
					message: '内容已复制到剪切板!',
					duration: 2000,
					type: 'success',
					offset: 100,
				});
			},
			// 复制失败时的回调函数
			copy_error(e) {
				this.$message({
					showClose: true,
					message: '抱歉，复制失败!',
					duration: 2000,
					type: 'error',
					offset: 100,
				});
			},
			// pageSize 改变时会触发
			SizeChange2(e) {
				this.table2_page.pagesize = e
				this.record_list()
				console.log(e, 'SizeChange2')
			},
			// currentPage 改变时会触发
			currChange2(e) {
				this.table2_page.current = e
				this.record_list()
				console.log(e, 'currChange2')
			},
			// 审核
			adopt(e, index) {
				if(retujudpower(this.is_powerEdit)) {
					if (index == 1) {
						this.currentAlert = e
						this.currentstatus = index
						this.import_member_show1 = true
					} else {
						this.$confirm('您确定要拒绝吗?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							let data = {
								record_id: e.record_id,
								status: 2,
							}
							this.editRecordlist(data)
						}).catch(() => {
					
						});
					}
				}
				


			},
			editRecordlist(data) {
				edit_recordlist(data).then(res => {
					console.log(res, 'edit_recordlist')
					if (res.code === 10000) {
						this.import_member_show1 = false
						this.$message({
							showClose: true,
							message: '修改成功',
							duration: 2000,
							type: 'success',
							offset: 100,
						});
						this.record_list()
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							duration: 2000,
							type: 'error',
							offset: 100,
						});
					}
				});
			},

			// ------------------------
			toCourse() {
				if(retujudpower(this.is_powerEdit)) {
					this.$router.push({path:'/set_up/WeCom/Configuration'})
				}
				
			},
			// 初始化数据
			initializationData() {
				this.synch_select_info = {
					class_info: true,
					label_info: true,
					member_info: true,
					group_info: true
				}
				this.progress_bar = 0
				this.class_state = 0
				this.label_state = 0
				this.member_state = 0
				this.group_state = 0
				this.class_msg = 0
				this.label_msg = 0
				this.member_msg = 0
				this.group_msg = 0
				this.data_num = {
					sum: 100,
					num: 0
				}
				this.userid = ''
				this.next_cursor = ''
				this.member_index = 0
				this.group_index = 0
				this.dialog_type = 1
			},

			// 打开同步弹窗
			openSynch() {
				if(retujudpower(this.is_powerEdit)) {
					this.initializationData()
					this.synch_show = true
					this.getQwMember()
				}
				
			},

			// 判断是否全部同步完成
			isSynch() {
				let that = this
				if (this.progress_bar === 100) {
					setTimeout(function() {
						that.dialog_type = 3
						that.synch_dialog.name = '同步成功'
					}, 1000)
				}
			},


			start_synch_dialog() {
				// 计算百分百
				if (this.synch_select_info.class_info) {
					this.data_num.num += 1
				}
				if (this.synch_select_info.label_info) {
					this.data_num.num += 1
				}
				if (this.synch_select_info.member_info) {
					this.data_num.num += 1
				}
				if (this.synch_select_info.group_info) {
					this.data_num.num += 1
				}


				if (this.synch_select_info.class_info) {
					this.class_state = 1
					this.synchroQwDepartment()
				} else if (this.synch_select_info.label_info) {
					this.label_state = 1
					this.synchroQwTag()
				} else if (this.synch_select_info.member_info) {
					this.member_state = 1
					this.synchroQwCustomer(this.member_list[this.member_index].userid)
				} else if (this.synch_select_info.group_info) {
					this.group_state = 1
					this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
				}

				this.dialog_type = 2
			},
			suspend_synch_dialog() {
				this.dialog_type = 3
			},
			return_synch_dialog() {
				this.synch_show = false
				this.$store.commit('clearCancelToken')
				this.initializationData()
			},

			close_synch_dialog() {
				this.synch_show = false
				this.$store.commit('clearCancelToken')
				this.initializationData()
			},



			getQwConfig() {
				getQwConfig().then(res => {
					console.log(res,'getQwConfig')
					if(res){
						if (res.code === 10000) {
							this.wechat_info = res.result
							this.info_loading = false
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: 2000,
								type: 'error',
								offset: 100,
							});
						}
					}
					
				})
			},

			// 同步部门
			synchroQwDepartment() {
				synchroQwDepartment().then(res => {
					if (res.code === 10000) {
						this.class_msg = res.result
						this.class_state = 2
						this.progress_bar += this.data_num.sum / this.data_num.num
						this.isSynch()
						if (this.synch_select_info.label_info) {
							this.label_state = 1
							this.synchroQwTag()
						} else if (this.synch_select_info.member_info) {
							this.member_state = 1
							this.synchroQwCustomer(this.member_list[this.member_index].userid)
						} else if (this.synch_select_info.group_info) {
							this.group_state = 1
							this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
						}
					}
				})
			},
			// 同步标签
			synchroQwTag() {
				synchroQwTag().then(res => {
					if (res.code === 10000) {
						this.label_msg = res.result
						this.label_state = 2
						this.progress_bar += this.data_num.sum / this.data_num.num
						this.isSynch()
						if (this.synch_select_info.member_info) {
							this.member_state = 1
							this.synchroQwCustomer(this.member_list[this.member_index].userid)
						} else if (this.synch_select_info.group_info) {
							this.group_state = 1
							this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
						}
					}
				})
			},
			// 同步客户
			synchroQwCustomer(userid, next_cursor) {
				synchroQwCustomer(userid, next_cursor).then(res => {
					if (res.code === 10000) {
						this.member_msg += res.result.data_count
						if (res.result.next_cursor != '') {
							this.synchroQwCustomer(res.result.userid, res.result.next_cursor)
						} else {
							if (this.member_index < this.member_list.length - 1) {
								this.member_index += 1
								this.synchroQwCustomer(this.member_list[this.member_index].userid)
							} else {
								this.member_state = 2
								this.progress_bar += this.data_num.sum / this.data_num.num
								this.isSynch()
								if (this.synch_select_info.group_info) {
									this.group_state = 1
									this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
								}
							}
						}
					}
				})
			},
			// 同步客户群
			synchroQwCustomerBase(userid, next_cursor) {
				synchroQwCustomerBase(userid, next_cursor).then(res => {
					if (res.code === 10000) {
						this.group_msg += res.result.data_count
						if (res.result.next_cursor != '') {
							this.synchroQwCustomerBase(res.result.userid, res.result.next_cursor)
						} else {
							if (this.group_index < this.member_list.length - 1) {
								this.group_index += 1
								this.synchroQwCustomerBase(this.member_list[this.group_index].userid)
							} else {
								this.group_state = 2
								this.progress_bar += this.data_num.sum / this.data_num.num
								this.isSynch()
							}
						}
					}
				})
			},


			// 获取已同步企微成员
			getQwMember() {
				getQwMember().then(res => {
					if (res.code === 10000) {
						this.member_list = res.result
					}
				})
			},
		}
	}
</script>

<style scoped>
	/deep/ .el-pagination.is-background .btn-next,
	/deep/ .el-pagination.is-background .btn-prev,
	/deep/ .el-pagination.is-background .el-pager li {
		margin-left: 10px;
	}

	/deep/ .el-table {
		border: solid 1px #eee;
	}

	/deep/ .el-pagination {
		padding: 2px 10px;
	}

	.wx_btn {
		cursor: pointer;
		font-size: 14px;
		text-align: center;
	}

	.wx_btn.btn1 {
		color: #27a538;
	}

	.wx_btn.btn2 {
		color: var(--delebtn);
	}

	.wx_btn.btn3 {
		color: rgba(166, 166, 166, 1);
	}

	.pagin_box {
		min-width: 940px;
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 67px;
	}

	.pagin_box.FlexStart {
		justify-content: flex-start;
	}

	.pagin_box.FlexEnd {
		justify-content: flex-end;
	}

	.wx_table {
		/* width: 100%; */
		margin-bottom: 16px;
		padding: 0 10px;
		min-width: 940px;
		max-height: 370px;
		overflow-y: auto;
	}

	.join_box {
		/* width: 100%; */
		min-width: 940px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 16px 0;
		padding: 0 10px;
	}

	.join_box .join_item:nth-of-type(1) {
		max-width: 460px;
	}

	.join_box .join_item {
		flex: 1;
		min-width: 460px;
		min-height: 168px;
		color: rgba(80, 80, 80, 1);
		background-color: rgba(249, 249, 249, 1);
		border-radius: 5px;
		font-size: 14px;
		display: flex;
		padding: 14px 10px 15px 20px;

	}

	.join_item .img_box {
		width: 140px;
		height: 140px;
		padding: 5px;
		margin-right: 19px;
		/* border: solid 1px red; */
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.join_item .img_box canvas {
		transform: scale(0.5);

		display: block;
	}

	.join_item .info {
		flex: 1;
		min-height: 138px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
	}

	.join_item .info .tit {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;

	}

	.join_item .info .tit span {
		color: rgba(56, 56, 56, 1);
		font-size: 16px;
		text-align: left;
		font-weight: 550;
	}

	.join_item .info .tit .copy {
		padding: 0 15px;
		height: 30px;
		color: rgba(0, 118, 254, 1);
		background-color: rgba(228, 237, 252, 1);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.join_item .info .txt {
		color: rgba(166, 166, 166, 1);
		font-size: 14px;
		text-align: left;
	}

	.join_item .info .url_txt {
		color: rgba(56, 56, 56, 1);
		font-size: 14px;
		text-align: justify;

		word-wrap: break-word;
		word-break: break-all;
		margin: 8px 0;
	}

	/* ---------------- */
	.wechat {
		width: 100%;
		background: #fff;
	}

	.wechat .info-box {
		height: 185px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #eee;
	}

	.wechat .info-box .info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 20px;
	}

	.wechat .info-box .info .name-box {
		margin-left: 20px;
	}

	.wechat .info-box .info .name-box .name {
		font-size: 16px;
		font-weight: 700;
		line-height: 21px;
		color: #000;
	}

	.wechat .info-box .info .name-box .id {
		max-width: 28em;
		font-size: 14px;
		line-height: 19px;
		color: #898989;
		margin-top: 7px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.wechat .info-box .btn .synch {
		height: 34px;
		border: none;
		background: rgb(39, 165, 56);
		margin-right: 15px;
		padding: 0 15px;
		color: #fff;
	}

	.wechat .info-box .btn .synch:hover {
		background: rgb(24, 134, 39);
	}

	.wechat .info-box .btn .access {
		height: 34px;
		border: none;
		background: var(--themeColors);
		margin-right: 15px;
		padding: 0 15px;
		color: #fff;
	}

	.wechat .info-box .btn .access:hover {
		background: var(--themeColorsHover);
	}

	.wechat .table {
		padding: 10px;
	}

	.wechat .table .title-box {
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}

	.wechat .table .title-box .title {
		font-size: 20px;
		line-height: 26px;
		color: var(--themeColors);
		font-weight: 700;
		margin: 0 8px;
	}

	.dialog .synch_select .title {
		font-size: 14px;
		color: rgba(166, 166, 166, 1);
	}

	.dialog .synch_select .check-box {
		margin-top: 15px;
	}

	/deep/ .dialog .synch_speed .el-progress-bar {
		width: 95%;
	}

	/deep/ .dialog .synch_speed .el-progress-bar__outer {
		height: 10px !important;
	}

	/deep/ .dialog .synch_speed .el-progress__text {
		font-size: 18px !important;
		font-weight: bold;
		margin-left: 25px;
	}

	.dialog .synch_speed .return_info {
		margin-top: 50px;
	}

	.dialog .synch_speed .return_info p {
		color: rgb(56, 56, 56);
		line-height: 2;
	}

	.dialog .synch_success {
		display: flex;
		justify-content: center;
	}

	.dialog .synch_success .title-box {
		width: 420px;
		margin-left: 15px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.dialog .synch_success .title-box .title {
		font-size: 16px;
		color: rgb(56, 56, 56);
	}

	.dialog .synch_success .title-box .small-title {
		font-size: 14px;
		color: rgb(166, 166, 166);
		margin-top: 10px;
	}



	.dialog .wait {
		font-size: 12px;
		color: rgb(166, 166, 166);
	}

	.dialog .ongoing {
		font-size: 12px;
		color: rgb(255, 141, 26);
	}

	.dialog .success {
		font-size: 12px;
		color: rgb(39, 165, 56);
	}

	.dialog .data-text {
		font-size: 12px;
		color: rgb(166, 166, 166);
	}

	.dialog .suspend {
		background: rgb(255, 141, 26);
		border-color: rgb(255, 141, 26);
	}

	.dialog .suspend:hover {
		background: #f77c00;
		border-color: #f77c00;
	}

	.dialog .blueBtn:focus {
		background: var(--themeColors);
		color: #fff;
		border-color: var(--themeColors);
	}

	.dialog .suspend:focus {
		background: rgb(255, 141, 26);
		color: #fff;
		border-color: rgb(255, 141, 26);
	}
</style>
